import React, { useEffect, useState } from "react";
import { Dropdown, Menu, Space, Grid, Modal, Tooltip } from "antd";
import { GlobalOutlined } from "@ant-design/icons";
import i18n from "i18next";
import { portalActions } from "store/portal-slice";
import { useDispatch, useSelector } from "react-redux";
import { LANGUAGES } from "./../../constants/supported_lang";
import { useSurveySrv } from "./useSurveySrv";
import { handleErrorNavigation } from "pages/ErrorPage/ErrorHandler";
import { useNavigate } from "react-router-dom";
import Language from "pages/Language/Language";
import { useTranslation } from "react-i18next";
import whitelabelConfig from "@whitelabel-config";
const LanguageDropdown = () => {
  const { t, i18n } = useTranslation();
  const { updateSelectedLanguageFromDropDown } = useSurveySrv();
  const dispatch = useDispatch();
  const surveyLanguage = useSelector((state) => state.portal.uiState.Language);
  const navigate = useNavigate();
  const [selectedLangCode, setSelectedLangCode] = useState(
    surveyLanguage || "en"
  );
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [pendingLangCode, setPendingLangCode] = useState(null);
  const [isDropdownDisabled, setIsDropdownDisabled] = useState(false);

  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  console.log("surveyLanguage..", surveyLanguage);
  console.log("selectedLangCode..", selectedLangCode);
  useEffect(() => {
    // if (surveyLanguage !== selectedLangCode) {
    //   setIsDropdownDisabled(true);
    // }
    //  const isConfirmed = localStorage.getItem("languageConfirmed") === "true";
    //  setIsDropdownDisabled(isConfirmed);
    if (surveyLanguage && i18n.language !== surveyLanguage) {
      i18n.changeLanguage(surveyLanguage);
      setSelectedLangCode(surveyLanguage);
    }
  }, []);

  const showConfirmationModal = (code) => {
    setPendingLangCode(code);
    setIsModalVisible(true);
  };

  const handleOk = () => {
    const selectedLanguage = LANGUAGES.find(
      (lang) => lang.code === pendingLangCode
    )?.id;
    console.log("selectedLanguage", selectedLanguage);
    const payLoad = {
      selectedLanguage,
    };
    console.log("payLoad...", payLoad);
    updateSelectedLanguageFromDropDown(selectedLanguage)
      .then((res: any) => {
        // Handle success response if needed
        console.log("Language update response:", res);
      })
      .catch((e) => {
        handleErrorNavigation(e, navigate, t);
      });

    localStorage.setItem("languageConfirmed", "true");
    console.log("pendingLangCode++++", pendingLangCode);
    localStorage.setItem("preferredLanguageForSurvey", pendingLangCode);
    dispatch(portalActions.updateSurveyLanguageState(pendingLangCode));
    dispatch(portalActions.updateLanguageState(pendingLangCode));

    if (pendingLangCode) {
      i18n.changeLanguage(pendingLangCode);
      setSelectedLangCode(pendingLangCode);
      dispatch(portalActions.updateLanguageState(pendingLangCode));
      // setIsDropdownDisabled(true); // Disable dropdown after confirmation
    }
    setIsModalVisible(false);
    setPendingLangCode(null);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setPendingLangCode(null);
  };

  const menu = (
    <Menu>
      {LANGUAGES.map((language) => (
        <Menu.Item
          key={language.id}
          onClick={() => showConfirmationModal(language.code)}
        >
          {language.label}
        </Menu.Item>
      ))}
    </Menu>
  );
  console.log("isDropdownDisabled", isDropdownDisabled);
  return (
    <div
      style={{
        position: "absolute",
        top: screens.md ? "8px" : "0",
        right: 0,
        padding: screens.md ? "0 20px" : "0 20px 0",
        display: "flex",
        flexDirection: screens.md ? "row" : "column",
        gap: "5px",
        alignItems: "center",
      }}
    >
      {/* Conditionally render the dropdown or disabled icon */}
      {/* {
      isDropdownDisabled ?
       (
        <Tooltip title="Language change has been confirmed. Dropdown disabled.">
          <GlobalOutlined
            style={{ fontSize: "24px", color: "gray", cursor: "not-allowed" }}
          />
        </Tooltip>
      ) : ( */}
      <Dropdown overlay={menu} trigger={["click"]}>
        <Space>
          <GlobalOutlined
            style={{ fontSize: "24px", color: "white", cursor: "pointer" }}
          />
        </Space>
      </Dropdown>
      {/* )} */}

      <p style={{ color: "white", margin: "0px" }}>{selectedLangCode}</p>

      <Modal
        title="Change Language"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="OK"
        cancelText="Cancel"
      >
        <p>
          {whitelabelConfig.uiSettings.languageConfirmationText}
          {/* You are changing the language to{" "} */}
          <strong>
            {" "}
            {LANGUAGES.find((lang) => lang.code === pendingLangCode)?.label ||
              pendingLangCode}
          </strong>
          .
        </p>
      </Modal>
    </div>
  );
};

export default LanguageDropdown;
